import { Route } from 'react-router-dom';

import AccessDenied from '../common/AccessDenied';
import { getUserRoles } from '../common/Common.utils';
import { RouteType } from './Route.types';

export default function RouteWithSubRoutes(route: RouteType) {
  const userRoles = getUserRoles();

  return (
    <Route
      path={route.path}
      render={(props) => {
        // route.roles is null or length === 0: there is no restriction, everyone can access this page
        // OR route.roles.includes(role): only person who has permission can access this page
        const isAuthorized =
          !route.roles ||
          route.roles.length === 0 ||
          userRoles.some((role) => route.roles?.includes(role));

        if (isAuthorized) {
          return <route.component {...props} routes={route.routes} />;
        }
        return <AccessDenied />;
      }}
      exact={route.exact}
    />
  );
}
